
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationTeamsResource,
} from '../models';
import {
    OrganizationTeamsResourceFromJSON,
    OrganizationTeamsResourceToJSON,
} from '../models';

export interface GetOrganizationTeamsRequest {
    organizationId: string;
}

/**
 * 
 */
export class OrganizationTeamsApi extends runtime.BaseAPI {

    /**
     * Get all teams in an organization
          */
    async getOrganizationTeamsRaw(requestParameters: GetOrganizationTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationTeamsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationTeamsResource>({
            path: `/client-settings/api/organizations/{organizationId}/teams`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationTeamsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get all teams in an organization
          */
    async getOrganizationTeams(requestParameters: GetOrganizationTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationTeamsResource> {
        const response = await this.getOrganizationTeamsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
